import type { PlaceMedia as PlaceMediaData } from './livingSpaceData';
import styles from './LivingSpace.module.scss';

interface PlaceMediaProps {
  media: PlaceMediaData;
  className?: string;
  index: string;
}

export function PlaceMedia({ media, className = '', index }: PlaceMediaProps) {
  return (
    <figure className={`${styles.media} ${className}`}>
      {media.src ? (
        <img
          src={media.src}
          srcSet={media.srcSet}
          sizes="(max-width: 767px) calc(100vw - 40px), 56vw"
          width={media.width}
          height={media.height}
          alt={media.alt}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <div className={styles.mediaPlaceholder} role="img" aria-label={media.alt}>
          <span className={styles.mediaIndex}>{index}</span>
          <span className={styles.mediaRequest}>Будущий кадр</span>
          <strong>{media.placeholder}</strong>
        </div>
      )}
    </figure>
  );
}
